import PropTypes from "prop-types"
import React, { Component } from "react"
import classNames from "classnames"
import { injectIntl, FormattedMessage } from "react-intl"
import { browserHistory } from "react-router"
import State from "../../stores/State"
import ButtonDropdown from "../elements/ButtonDropdown"
import ArticleStyleButton from "../elements/ArticleStyleButton"
import { dispatch } from "../../Dispatcher"
import { setArticleStyle, setPerPage, searchSort } from "../../actions"
import { VALID_SORTS, SET_ARTICLE_STYLES } from "../../constants"
import searchMessages from "../../messages/search"
import listMessages from "../../messages/lists"
import settingsMessages from "../../messages/settings"
import { getAccountSettings } from "../../scripts/accountSettings"
import { getStyles, getStyleTag } from "../../styles/dynamicStyles"

class SearchDisplayTools extends Component {
  static defaultProps = {
    articleStyles: SET_ARTICLE_STYLES,
    withSort: true
  }

  getFromGlobalState = () => ({
    perPage: State.get("perPage"),
    sort: State.get("sort") || State.get("defaultSort"),
    articleStyle: State.get("articleStyle")
  })

  state = {
    show: false,
    ...this.getFromGlobalState()
  }

  componentDidMount() {
    this._stateListener = State.addListener(() => {
      this.setState(this.getFromGlobalState())
    })
  }

  componentWillUnmount() {
    if (this._stateListener) {
      this._stateListener.remove()
    }
  }

  handlePageSize = size => {
    dispatch(setPerPage(size))
    this.toggle()
  }

  handleArticleStyle = style => {
    dispatch(setArticleStyle(style))
    this.toggle(style)
  }

  handleSort = e => {
    dispatch(searchSort(e.target.value))
  }

  toggle = style => {
    const searchMap = style === "map"
    if (State.get("searchMap") !== searchMap) {
      const searchParams = new URLSearchParams(window.location.search)
      if (searchMap) {
        searchParams.set("map", searchMap)
      } else {
        searchParams.delete("map")
      }
      const params = searchParams.toString()
      const newRelativePathQuery = params
        ? `${window.location.pathname}?${params}`
        : window.location.pathname
      browserHistory.push(newRelativePathQuery)
    }
    this.setState({
      show: !this.state.show
    })
  }

  render() {
    const { perPage, show, sort, articleStyle } = this.state
    const { articleStyles, withSort, intl } = this.props
    const activeButtonStyle = articleStyles.find(
      item => item.id === articleStyle
    )
    const accountSettings = getAccountSettings(
      intl.formatMessage(settingsMessages.authenticAccountId)
    )
    const contentStyleType = accountSettings.settings.style.content
    const viewIconName =
      contentStyleType === "default"
        ? "display"
        : `view-${activeButtonStyle.id}`

    return (
      <div
        className="panel__tools search-display-tools"
        role="menubar"
        style={getStyles("c-results__search-display-tools")}
      >
        {getStyleTag(["c-results-panel__display-option", "search-results"])}

        <div
          className="c-results__dropdown-wrapper"
          style={getStyles("c-results__dropdown-wrapper")}
        >
          {contentStyleType === "type1" && (
            <span style={getStyles("button-dropdown__text")}>Layout</span>
          )}

          <ButtonDropdown
            title={intl.formatMessage(searchMessages.searchResultsDisplay)}
            extraClasses="panel__tool panel__tool--display"
            triggerIcon={viewIconName}
            dropdownFromRight
            expanded={show}
            handleClick={e => {
              e.preventDefault()
              this.setState({
                show: !this.state.show
              })
            }}
          >
            <div
              className="c-results-panel__display"
              style={getStyles("c-results-panel__display")}
            >
              <h6 className="c-results-panel__display-title">
                <FormattedMessage {...searchMessages.displayOptions} />
              </h6>
              <div className="c-results-panel__display-group">
                {articleStyles.map((style, i) => (
                  <ArticleStyleButton
                    key={style.id}
                    title={intl.formatMessage(searchMessages[style.message])}
                    handleClick={this.handleArticleStyle}
                    active={articleStyle === style.id}
                    style={style.id}
                  />
                ))}
              </div>
              <h6 className="c-results-panel__display-title">
                <FormattedMessage {...searchMessages.noOfResults} />
              </h6>
              <div className="c-results-panel__display-group">
                <button
                  role="menuitem"
                  title={intl.formatMessage(searchMessages.changeResultsCount, {
                    count: 30
                  })}
                  className={classNames(
                    "c-results-panel__display-option c-results-panel__display-option--text ",
                    { "state-active": perPage === 30 }
                  )}
                  onClick={e => this.handlePageSize(30)}
                >
                  30
                </button>
                <button
                  role="menuitem"
                  title={intl.formatMessage(searchMessages.changeResultsCount, {
                    count: 60
                  })}
                  className={classNames(
                    "c-results-panel__display-option c-results-panel__display-option--text ",
                    { "state-active": perPage === 60 }
                  )}
                  onClick={e => this.handlePageSize(60)}
                >
                  60
                </button>
                <button
                  role="menuitem"
                  title={intl.formatMessage(searchMessages.changeResultsCount, {
                    count: 90
                  })}
                  className={classNames(
                    "c-results-panel__display-option c-results-panel__display-option--text ",
                    { "state-active": perPage === 90 }
                  )}
                  onClick={e => this.handlePageSize(90)}
                >
                  90
                </button>
              </div>
            </div>
          </ButtonDropdown>
        </div>

        {withSort && (
          <div className="select" style={getStyles("select")}>
            {getStyleTag(["select"])}
            <select
              onChange={this.handleSort}
              value={sort}
              className="panel__tool"
              name="sort"
              id="sort"
              title={intl.formatMessage(searchMessages.searchResultSortOrder)}
            >
              {VALID_SORTS.map(o => (
                <option key={o.v} value={o.v} role="option">
                  {o.id in listMessages
                    ? intl.formatMessage(listMessages[o.id])
                    : o.l}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>
    )
  }
}

SearchDisplayTools.propTypes = {
  articleStyles: PropTypes.array,
  withSort: PropTypes.bool
}

export default injectIntl(SearchDisplayTools)



// WEBPACK FOOTER //
// ./webapp/components/modules/SearchDisplayTools.js